import InfinityLoader from '@/components/common/infinityLoader'
import {
  CheckValidityGroupBookingDocument,
} from '@/types/graphql/types'
import validateEmailList from '@/util/validEmailList'
import { useQuery } from '@apollo/client'
import {
  ActionIcon,
  Button,
  LoadingOverlay,
  Radio,
  RadioGroup,
  Text,
  TextInput,
} from '@mantine/core'
import { formList, useForm } from '@mantine/form'
import dayjs from 'dayjs'
import { parseInt } from 'lodash'
import { useSession } from 'next-auth/react'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { Plus, X } from 'tabler-icons-react'

type GroupFormType = {
    isGroupPay: boolean
    groupTrainee: Array<{ email: string }>
    methodOfDelivery: 'ONLINE' | 'ONSITE' | undefined
  }

 const AddGroupBooking = ({
    onSubmit,
  }: {
    onSubmit: (values: GroupFormType) => void
  }) => {
    const { t, lang } = useTranslation('common')
    const isArabic = lang === 'ar'
    const { query } = useRouter()
    const { data: userData } = useSession()
    const { data, loading: dataLoading } = useQuery(
      CheckValidityGroupBookingDocument,
      {
        variables: { where: { id: parseInt(query.id as string) } },
      },
    )
  
    const minRegs =
      data?.findUniqueEvent?.pricingPlan?.groupDiscountMinNumberOfRegistrants ?? 0
  
    const form = useForm({
      initialValues: {
        isGroupPay: true,
        groupTrainee: formList(
          [] as Array<{
            email: string
          }>,
        ),
        methodOfDelivery: undefined as 'ONLINE' | 'ONSITE' | undefined,
      },
    })
  
    useEffect(() => {
      form.setValues({
        ...form.values,
        groupTrainee: formList(
          Array.from({ length: minRegs - 1 }, () => ({ email: '' })) as Array<{
            email: string
          }>,
        ),
      })
    }, [minRegs])
  
    const fields = form.values.groupTrainee.map((_, index) => (
      <div key={index as any}>
        <div className="mt-2 flex items-center gap-2">
          <TextInput
            placeholder="infinity@gmail.com"
            {...form.getListInputProps('groupTrainee', index, 'email')}
            className="flex-grow"
          />
          <ActionIcon onClick={() => form.removeListItem('groupTrainee', index)}>
            <X color="red" size={18} strokeWidth={2} />
          </ActionIcon>
        </div>
      </div>
    ))
  
    const validEmails = validateEmailList(
      form.values.groupTrainee.map(e => e?.email),
    )
  
    const hasMinNumberOfTrainees =
      form.values.groupTrainee.length >=
      (data?.findUniqueEvent?.pricingPlan?.groupDiscountMinNumberOfRegistrants ??
        0) -
        1
    const expired = dayjs(new Date()).isAfter(
      data?.findUniqueEvent?.pricingPlan?.groupDiscountEndDate,
      'D',
    )
  
    return (
      <form
        onSubmit={form.onSubmit(v =>
          onSubmit({
            ...v,
            groupTrainee: [
              { email: userData?.user.email ?? '' },
              ...v.groupTrainee,
            ],
          }),
        )}
        style={{ direction: isArabic ? 'rtl' : 'ltr' }}
        className="relative"
      >
        <LoadingOverlay visible={dataLoading} loader={<InfinityLoader />} />
        <div>
          <div>
            <div className="mt-2 flex items-center gap-2">
              <TextInput
                label={t('groupMembersEmails')}
                placeholder="infinity@gmail.com"
                value={userData?.user.email ?? ''}
                className="flex-grow"
                disabled
              />
            </div>
          </div>
          {fields}
        </div>
        <ActionIcon
          color="primary"
          variant="light"
          className="mt-2"
          onClick={() => form.addListItem('groupTrainee', { email: '' })}
        >
          <Plus size={24} />
        </ActionIcon>
        <div className="py-4">
          {/*  <Checkbox
            label={t('groupPaymentCheckbox')}
            {...form.getInputProps('isGroupPay', {
              type: 'checkbox',
            })}
          /> */}
          <RadioGroup
            color="rgba(16, 222, 208, 1)"
            value={form.values.isGroupPay.toString()}
            onChange={(o: string) =>
              form.setFieldValue('isGroupPay', JSON.parse(o))
            }
            orientation="vertical"
            label={t('groupPaymentCheckbox')}
            required
          >
            <Radio value="true" label={t('groupPaymentYes')} />
            <Radio value="false" label={t('groupPaymentNo')} />
          </RadioGroup>
        </div>
        <div className="text-center">
          <p>
            {expired ? (
              <Text color="red">{t('groupDiscountExpired')}</Text>
            ) : !hasMinNumberOfTrainees ? (
              <Text color="red">
                {`${t('minNumberOfTrainees')} ${
                  data?.findUniqueEvent?.pricingPlan
                    ?.groupDiscountMinNumberOfRegistrants
                }`}
              </Text>
            ) : (
              !validEmails.success && (
                <Text color="red">{t('invalidEmails')}</Text>
              )
            )}
          </p>
        </div>
        <div className="flex justify-center pt-2 gap-2">
          <Button
            type="submit"
            disabled={!hasMinNumberOfTrainees || expired || !validEmails.success}
          >
            {t('save')}
          </Button>
        </div>{' '}
      </form>
    )
  }
  export default AddGroupBooking